var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('delivery-type'),_c('delivery-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }